// @flow
import { error } from './common';
import * as types from '../types/reports';
import type { REPORT_TYPE } from '../types/reports';

export const setReport = (key: string): types.SET_REPORT_TYPE => ({
  type: types.SET_REPORT,
  payload: {
    key,
  },
});

export const startFetchReport = (
  key: string,
  selectedElement: number,
  date_range: string,
): types.START_FETCHING_REPORT_TYPE => ({
  type: types.START_FETCHING_REPORT,
  payload: {
    key,
    selectedElement,
    date_range,
  },
});

export const fetchReportSucceed = (report: REPORT_TYPE): types.REPORT_FETCH_SUCCEEDED_TYPE => ({
  type: types.REPORT_FETCH_SUCCEEDED,
  payload: report,
});

export const fetchReportFaied = error(types.REPORT_FETCH_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/reports.js